module.exports = __WEBPACK_EXTERNAL_MODULE_378__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 378
// module chunks = 0